(function () {
    'use strict';
    EO_DateDurationSelectorController.$inject = ['$scope', '$attrs', '$element'];

    function EO_DateDurationSelectorController($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.showEndDate = false;
        $ctrl.disableEndTime = false;

        $ctrl.showEndDate_changed = showEndDate_changed;
        $ctrl.getClass = getClass;
        $ctrl.minStartDate = new Date();

        loadAll();

        function loadAll() {
            if (!$ctrl.displayMode)
                $ctrl.displayMode = 'HORIZONTAL'; // HORIZONTAL - VERTICAL
        }

        function showEndDate_changed() {
            if (!$ctrl.showEndDate)
                $ctrl.endDate = null;
        }

        function getClass() {
            if ($ctrl.displayMode == 'VERTICAL')
                return 'col-lg-12 col-md-12 vertical-mode';
            else
                return 'col-lg-4 col-md-4';
        }

    }


    var EO_DateDurationSelector = {
        templateUrl: 'app/components/eyeson/date-duration-selector/eyeson.date-duration-selector.template.html',
        controller: EO_DateDurationSelectorController,
        bindings: {
            startDate: '=',
            endDate: '=',
            onlyShowStartDate: '=?',
            showEndDate: "=?",
            displayMode: "=?"
        }

    };

    angular
        .module('tikonApp')
        .component('eoDateDurationSelector', EO_DateDurationSelector)


})();
